/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmFineTuningCancel } from "../../funcs/llmFineTuningCancel.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CancelFineTuningJobRequest$inboundSchema,
};

export const tool$llmFineTuningCancel: ToolDefinition<typeof args> = {
  name: "llm-fine-tuning-cancel",
  description: `Cancel a fine-tuning job

Immediately cancel a fine-tuning job.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmFineTuningCancel(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
